module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "intro-to-ghg-center--cover.b0e19b27.jpg";